<template>
  <div>
    <div class="aside-title">授权超时，请重新扫码</div>
    <div
      v-if="url && url != 'request is too requently, please later try again'"
      id="login_container"
      class="aside-img-no"
    >
      <img :src="url" alt="" />
    </div>
    <div v-else class="aside-img" @click="flush"></div>
  </div>
</template>

<script>
import { accountLogin, generateAccessTokenUrl } from "@/api/login";
import { wxbaseurl } from "@/api/common.js";

export default {
  name: "wxQrcode",
  data() {
    return {
      url: "",
      timmer1: null
    };
  },
  methods: {
    async flush() {
      clearInterval(this.timmer1);
      this.timmer1 = null;
      await this.getWxLoginUrl();
    },

    //TODO: 第一步 获取二维码接口
    async getWxLoginUrl() {
      var that = this;
      try {
        //获取微信接口需要的ticket
        const wxurl = await generateAccessTokenUrl();
        if (this.testR(wxurl)) {
          this.$nextTick(() => {
            that.url = `${wxbaseurl}/cgi-bin/showqrcode?ticket=${wxurl.data.resp_data.ticket}`;
          });
          that.createTimmer();
          var data = {
            access_code: wxurl.data.resp_data.code,
            account_type: "access_code"
          };
          const accloginres = await accountLogin(JSON.stringify(data));
          if (
            this.testR(accloginres)
          ) {
            localStorage.setItem(
              "access_token",
              accloginres.data.resp_data.access_token
            );
            localStorage.setItem(
              "expire_time",
              accloginres.data.resp_data.expire_time
            );
            this.$emit("showQrCode",false);
            clearInterval(that.timmer1);
            this.timmer1 = null;
            this.url = "";
          } else {
            this.$emit("showQrCode",true);
            clearInterval(that.timmer1);
            that.timmer1 = null;
            that.url = "";
            that.snapshot = false;
          }
        } else {
          this.$emit("showQrCode",true);
          that.url = "";
          that.snapshot = false;
          clearInterval(that.timmer1);
          that.timmer1 = null;
        }
        return;
      } catch (e) {
        this.$emit("showQrCode",true);

        this.warnMessage(JSON.stringify(e));
        this.url = "";
        clearInterval(this.timmer1);
        this.timmer1 = null;
      }
    },
    //TODO: 定时器
    async createTimmer(counts = 0) {
      var that = this;
      var count = counts;
      this.timmer1 = setInterval(() => {
        //控制循环次数  一分钟之后重新请求
        if (count > 60) {
          that.warnMessage("扫码或授权超时！");
          that.url = "";
          that.snapshot = false;
          clearInterval(that.timmer1);
          that.timmer1 = null;
          return;
        }
        count++;
      }, 2000);
    }
  }
};
</script>
<style lang="less" scoped>
.aside-title{
  color:#fff;
}
.aside-img-no {
  width: 150px;
  height: 150px;
  img {
    width: 150px;
    height: 150px;
  }
}
.aside-img {
  width: 150px;
  height: 150px;
  img {
    width: 150px;
    height: 150px;
  }
}
.aside-img::before {
  position: absolute;
  content: "点击刷新";
  // display: inline-block;
  width: 150px;
  height: 150px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  line-height: 9;
  cursor: pointer;
}
</style>
